import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import useBeforeunload from '../useBeforeunload';
import { ANALYZER_ACTION, ANALYZER_ENTITY, CONTENT_KEY } from '../../commons/constants';
import { RootState } from '../../redux/store';
import { getHomeProfileTreeData } from '../../redux/selectors/homeProfile.selector';
import { getFloorName } from '../../utils';

type UseAnalyzerHomeProfilePropsTypes = {
  initial: boolean;
};

const useAnalyzerHomeProfile = (props: UseAnalyzerHomeProfilePropsTypes): void => {
  const { initial } = props;

  const [homeProfileCode, setHomeProfileCode] = useState<string>();
  const [homeProfileName, setHomeProfileName] = useState<string>();

  const contentActiveKey = useSelector((state: RootState) => state.projectModel.contentActiveKey);
  const isActivityWindow = useSelector((state: RootState) => state.layoutModel.isActivityWindow);
  const homeId = useSelector((state: RootState) => state.homeProfileModel.homeId);
  const { project, projectItem, floor, item } = useSelector(getHomeProfileTreeData);

  const homeProfileAnalyzer = (action: string, code: string, name: string) => {
    if (!project || !projectItem) return;

    if (window && window.ClikTracker && window.ClikTracker.sendCustomTrack) {
      // current not support tracking villa block page home profile;
      // hotfix 6/7 tracking home profile send data building and block villa common "building_code" ;
      window.ClikTracker.sendCustomTrack(action, ANALYZER_ENTITY.HOME_PROFILE, {
        project_code: project.code,
        project_name: project.name,
        building_code: projectItem.code,
        building_name: projectItem.name,
        floor_code: floor ? floor.code : null,
        floor_name: floor ? getFloorName(floor.name) : null,
        floor_number: floor ? floor.floorNumber : null,
        homeprofile_code: code,
        homeprofile_name: name,
      });
    }
  };

  // run event when close tab window or reload page
  useBeforeunload(() => {
    if (!initial) return;
    if (homeProfileCode) {
      homeProfileAnalyzer(ANALYZER_ACTION.CLOSED, homeProfileCode, homeProfileName);
    }
  });

  // useEffect homeProfile
  useEffect(() => {
    if (!window) return;
    if ((!item && homeProfileCode) || (item && homeProfileCode && homeProfileCode !== item.code)) {
      homeProfileAnalyzer(ANALYZER_ACTION.CLOSED, homeProfileCode, homeProfileName);
      if (!item) {
        setHomeProfileName(undefined);
        setHomeProfileCode(undefined);
      }
    }

    // check content page
    if (contentActiveKey !== CONTENT_KEY.HOME_PROFILE.key || !initial) return;
    // case view homeProfile
    if (!homeProfileCode && item) {
      setHomeProfileName(item.name);
      setHomeProfileCode(item.code);
      homeProfileAnalyzer(ANALYZER_ACTION.VIEWED, item.code, item.name);
    }

    if (!homeProfileCode) return;
    // case interrupted homeProfile
    if (!isActivityWindow && item) {
      homeProfileAnalyzer(ANALYZER_ACTION.INTERRUPTED, homeProfileCode, homeProfileName);
    }

    // case resumed homeProfile
    if (isActivityWindow && item) {
      homeProfileAnalyzer(ANALYZER_ACTION.RESUMED, homeProfileCode, homeProfileName);
    }
  }, [initial, isActivityWindow, homeId]);
};

export default useAnalyzerHomeProfile;
